const AIConversationHelpers = {
    swr: {
        history: (diagramId: string) => `/api/diagramAIMessagesHistory/${diagramId}`,
        messages: (diagramId: string, conversationId: string) =>
            `/api/diagramAIMessages/${diagramId}/${conversationId}`,
    },
};

export { AIConversationHelpers };
